import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    // Convertir en nombre si string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    // Vérifier si c'est un nombre valide
    if (isNaN(numValue)) {
      return String(value);
    }

    // ✅ Formater avec espace comme séparateur de milliers (locale fr-FR)
    return numValue.toLocaleString('fr-FR');
  }
}
